/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Panel 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/components/Button.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 25.
 */
import { Button as ButtonBase } from '@components/button/Button';
import { Segmented as SegmentedBase } from '@components/button/Segmented';
import { Profile as ProfileBase } from '@components/button/Profile';

export class Button extends ButtonBase {}
export namespace Button {
    export const Segmented = SegmentedBase;
    export const Profile = ProfileBase;
}
